<template>
  <div class="specialActivityArea">
    <div class="specialActivity" :style="{ background: dataSource.bgColor }">
      <div class="pr-56">
        <Header class="header"></Header>
        <el-image
          :fit="'contain'"
          id="specialActivity-banner"
          class="bannerImg"
          :src="dataSource.pcMainImg"
          alt="banner"
        />
        <div class="contentArea">
          <div class="content" id="specialActivity-dynamics">
            <Floor
              v-for="(item, index) in dataSource.floors"
              :dataSource="dataSource"
              :info="item"
              :id="'floor_' + index"
            ></Floor>
          </div>
          <LeftMenu
            v-if="dataSource.showTopFloorNav"
            :dataSource="dataSource"
          ></LeftMenu>
        </div>
      </div>
      <RightNav></RightNav>
    </div>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
import Header from "@/views/layout/header.vue";
import Footer from "@/views/layout/footer.vue";
import LeftMenu from "./components/leftMenu.vue";
import RightNav from "./components/rightNav.vue";
import Floor from "./components/floor.vue";
import { purchaseInfoBuringPoint } from "../../../utils/eventTracking";

export default {
  name: "specialActivity",
  components: {
    Header,
    LeftMenu,
    RightNav,
    Floor,
    Footer,
  },
  data() {
    return {
      dataSource: {},
      bannerHeight: 600,
    };
  },

  mounted() {
    const { activityId } = this.$route.query;
    this.activityId = activityId;
    this.getUserInfo();
    this.getInfo();
  },
  methods: {
    getUserInfo() {
      this.bus.$emit("refushUserInfo");
    },
    getInfo() {
      if (!this.activityId) {
        this.$message.warning("没有此活动");
        this.$router.push("/");
        return;
      }
      this.$http
        .get(
          `/front/cross/commodity-user/activity/topic/details?activityId=${this.activityId}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            purchaseInfoBuringPoint(this.activityId, 3);
            console.log(res.data);
            this.dataSource = res.data;
            this.setTitle();
          }
        });
    },
    setTitle() {
      document.title = this.dataSource.title || "plantmate";
    },
  },
  beforeDestroy() {
    window.onreset = () => {};
  },
  beforeCreate() {
    console.log("beforeCreate");
    window.onresize = jumpLink;
    jumpLink();
    function jumpLink() {
      const w = window.screen.width;
      const minWidth = 900;
      if (w < minWidth) {
        const host = window.location.host;
        const urlArr = window.location.search.split("?");
        const query = Object.fromEntries(
          (urlArr[1] || "").split("&").map((i) => i.split("="))
        );

        if (host.includes("10.10.56") || host.includes("localhost")) {
          window.location.href =
            window.location.protocol +
            "//" +
            window.location.hostname +
            ":5000/#/pages/specialActivity/index?activityId=" +
            query.activityId;
        } else if (host.includes("predev")) {
          window.location.href =
            "http://predevm.plantmate.supcon.com:8888/#/pages/specialActivity/index?activityId=" +
            query.activityId;
        } else if (host.includes("pretest")) {
          window.location.href =
            "http://pretestm.plantmate.supcon.com:8888/#/pages/specialActivity/index?activityId=" +
            query.activityId;
        } else if (host.includes("uat2")) {
          window.location.href =
            "https://uat2m-plantmate.supcon.com:8888/#/pages/specialActivity/index?activityId=" +
            query.activityId;
        } else {
          window.location.href =
            "https://m.plantmate.com/#/pages/specialActivity/index?activityId=" +
            query.activityId;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.specialActivityArea {
  // min-width: 1500px;
}
.specialActivity {
  display: flex;
  justify-content: center;
  padding-bottom: 24px;

  .pr-56 {
    padding-right: 56px;
  }
  .contentArea {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .content {
    width: 1200px;
  }
}
.header {
  background-image: none !important;
  background: #fff;
}

.bannerImg {
  width: 100%;
  object-fit: contain;
}
.footer {
  margin-right: 56px;
}
</style>
